module.exports = __webpack_public_path__ + "img/previewDocSvg.e0d4104a.svg";